import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";

const QuantityControl = ({ value = 1, disabled = false, onDecrease = () => {}, onIncrease = () => {}, onChange = () => {} }) => (
    <div className="cart-qty-row">
        <Button
            type="button"
            icon="pi pi-minus"
            className="p-button-text p-button-sm"
            disabled={disabled}
            onClick={onDecrease}
            aria-label="Disminuir cantidad"
        />
        <InputNumber
            value={Number(value || 1)}
            min={1}
            disabled={disabled}
            useGrouping={false}
            onValueChange={(event) => onChange(event.value)}
            inputClassName="cart-qty-input"
        />
        <Button
            type="button"
            icon="pi pi-plus"
            className="p-button-text p-button-sm"
            disabled={disabled}
            onClick={onIncrease}
            aria-label="Aumentar cantidad"
        />
    </div>
);

export default QuantityControl;
